import RegisterCard from './RegisterCard';

export default RegisterCard;
